import React, {Component} from "react";
import {Link} from "react-router";
import {currentSiteName} from "../../service/SiteService";

class UnauthenticatedNav extends Component {
    render() {
        return (
            <nav className="navbar navbar-inverse navbar-fixed-top top-nav">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                                data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar" />
                            <span className="icon-bar" />
                            <span className="icon-bar" />
                        </button>
                        <div className="visible-xs navbar-brand">{this.props.title}</div>
                        <Link className="hidden-xs navbar-brand" to="/">{currentSiteName}</Link>
                    </div>

                    <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                        <ul className="nav navbar-nav">
                            <li className={ this.props.tab === 'home' && "active" }><Link to="/"><i
                                className="icon icon-home"/> Home <span className="sr-only">(current)</span></Link></li>
                            <li className={ this.props.tab === 'register' && "active" }><Link to="/register"><i
                                className="icon icon-star"/> Register</Link></li>
                            <li className={ this.props.tab === 'docs' && "active" }><Link to="/docs"><i className="icon icon-help-with-circle"/> Documentation</Link></li>
                            <li className={ this.props.tab === 'pricing' && "active" }><Link to="/pricing"><i className="icon icon-credit"/> Pricing</Link></li>
                        </ul>
                        <ul className="nav navbar-nav navbar-right">
                            <li className={ this.props.tab === 'login' && "active" }><Link to="/login"><i
                                className="icon icon-login"/> Log in</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

UnauthenticatedNav.propTypes = {
    tab: React.PropTypes.string,
    title: React.PropTypes.string
};

UnauthenticatedNav.defaultProps = {
    title: currentSiteName
};

export default UnauthenticatedNav;



// WEBPACK FOOTER //
// ./src/modules/common/nav/UnauthenticatedNav.js